import * as constants from "../constants";

export default {

    OnSuccess(description) {
        console.log(description);
    },

    OnError(resp, description) {
        console.log(resp + description);
    },
    
    OnUnauthorized(){
        window.location.reload();
    },

    GetSearch: async function () {
        
        return await fetch(constants.API_ENDPOINT_NEW_VEHICLES_SEARCH + "/filters", {
            method: constants.HTTP_METHOD_GET
        }).then(async resp => {
            if (!resp.ok) {
                if (resp.status >= 500) {
                    this.OnError(resp, "Ocorreu uma anomalia ao carregar os Anúncios");
                    return null;
                }
            }

            return await resp.json();
        });
    },

    UpdateSearch: async function (filter) {
        return await fetch(constants.API_ENDPOINT_NEW_VEHICLES_SEARCH, {
            method: constants.HTTP_METHOD_PUT,
            headers: constants.HTTP_HEADERS_JSON,
            body: JSON.stringify(filter)
        }).then(resp => {
            if (!resp.ok) {
                if (resp.status >= 500) {
                    this.OnError(resp, "Ocorreu uma anomalia ao carregar os Anúncios");
                    return null;
                }
            }
        });

    },
    Search: async function (pageNum) {
        let reqUriParams = ``;
        if (pageNum != '') {
            reqUriParams += `p=${pageNum}`;
        }
        return await fetch(constants.API_ENDPOINT_NEW_VEHICLES_SEARCH + `?${reqUriParams}`, {
            method: constants.HTTP_METHOD_GET
        }).then(async resp => {
            if (!resp.ok) {
                if (resp.status >= 500) {
                    this.OnError(resp, "Ocorreu uma anomalia ao carregar os Anúncios");
                    return null;
                }
            }

            return await resp.json();
        });
    },

    DeleteSearch: async function () {

        return await fetch(constants.API_ENDPOINT_NEW_VEHICLES_SEARCH, {
            method: constants.HTTP_METHOD_DELETE
        }).then(resp => {
            if (!resp.ok) {
                if (resp.status >= 500) {
                    this.OnError(resp, "Ocorreu uma anomalia ao carregar os Anúncios");
                    return null;
                }
            }

            return resp.json();
        });
    },

    GetSearchData: async function () {
        return await fetch(constants.API_ENDPOINT_NEW_VEHICLES_DATA, {
            method: constants.HTTP_METHOD_GET
        }).then(resp => {
            if (!resp.ok) {
                if (resp.status >= 500) {
                    this.OnError(resp, "Ocorreu uma anomalia ao carregar a lista de marcas");
                    return null;
                }
            }

            return resp.json();
        });
    },

    GetModels: async function (brands) {

        let q = [];
        for (let i = 0; i < brands.length; i++) {
            q.push(`b=${brands[i]}`);
        }

        return await fetch(constants.API_ENDPOINT_NEW_VEHICLES_MODELS + `?${q.join("&")}`, {
            method: constants.HTTP_METHOD_GET,
        }).then(async resp => {
            if (!resp.ok) {
                if (resp.status >= 500) {
                    this.OnError(resp, "Ocorreu uma anomalia ao carregar a lista de marcas");
                    return null;
                }
            }

            return await resp.json();
        });
    },
    GetSavedSearchesCount: async function(){
        return await fetch(constants.API_ENDPOINT_NEW_VEHICLES_SAVED_SEARCHES + '/count', {
            method: constants.HTTP_METHOD_GET
        }).then(async resp => {
            if (!resp.ok) {
                if (resp.status >= 500) {
                    return null;
                }
                if(resp.status == 401){
                    this.OnUnauthorized();
                    return null;
                }
            }

            return await resp.json();
        });
    },
    SaveSearch: async function(name){
        return await fetch(constants.API_ENDPOINT_NEW_VEHICLES_SAVED_SEARCHES + '?name=' + name, {
            method: constants.HTTP_METHOD_POST
        }).then(async resp => {
            if (!resp.ok) {
                if (resp.status >= 500) {
                    this.OnError(resp, "Ocorreu uma anomalia ao salvar a pesquisa.");
                    return null;
                }
                if(resp.status == 401){
                    this.OnUnauthorized();
                    return null;
                }
            }

            return await resp.json();
        });
    },
    GetSavedSearches: async function(){
        return await fetch(constants.API_ENDPOINT_NEW_VEHICLES_SAVED_SEARCHES, {
            method: constants.HTTP_METHOD_GET
        }).then(async resp => {
            if (!resp.ok) {
                if (resp.status >= 500) {
                    this.OnError(resp, "Ocorreu uma anomalia ao carregar as pesquisas salvas");
                    return null;
                }
                if(resp.status == 401){
                    this.OnUnauthorized();
                    return null;
                }
            }

            return await resp.json();
        });
    },
    DeleteSavedSearch: async function(id){
        return await fetch(constants.API_ENDPOINT_NEW_VEHICLES_SAVED_SEARCHES + '?id=' + id, {
            method: constants.HTTP_METHOD_DELETE
        }).then(async resp => {
            if (!resp.ok) {
                if (resp.status >= 500) {
                    this.OnError(resp, "Ocorreu uma anomalia ao excluir uma pesquisa");
                    return null;
                }
                if(resp.status == 401){
                    this.OnUnauthorized();
                    return null;
                }
            }

            return await resp.json();
        });
    },


}